import {useConfigHeader} from "hooks/useConfig"
import {useApiDefaults} from "hooks/useApiDefaults"
import {useNavigate} from "react-router-dom"
import {useParams} from "react-router-dom"
import {useDispatch} from "react-redux"
import {useState} from "react"
import axios from "config/axios"
import {getCartList} from "redux/actions"

function ReOrder() {
  const {allowReOrderEcomOrder, allowReOrderCateringAndMealkitOrder} = useConfigHeader()
  const apiDefaults = useApiDefaults()
  const navigate = useNavigate()
  const params = useParams()
  const dispatch = useDispatch()

  const isEcom = params?.orderid?.length > 0
  let orderId, apiEndpoint, orderIdKey, redirectUrl, allowReOrder
  if (isEcom) {
    orderId = params?.orderid
    apiEndpoint = "/AOGEcomReOrder"
    orderIdKey = "order_id"
    redirectUrl = "/your-cart"
    allowReOrder = allowReOrderEcomOrder
  } else {
    orderId = params?.mealKitId
    apiEndpoint = "/AOGCateringAndMealkitReOrder"
    orderIdKey = "meal_order_id"
    redirectUrl = "/your-cart/catering-meal"
    allowReOrder = allowReOrderCateringAndMealkitOrder
  }
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const handleReOrder = async () => {
    try {
      setLoading(true)
      setError("")

      const response = await axios.post(apiEndpoint, {
        ...apiDefaults,
        [orderIdKey]: orderId,
      })
      if (response?.data?.status === "success") {
        dispatch(getCartList(apiDefaults))
        setTimeout(() => {
          navigate(redirectUrl)
        }, 300)
      } else {
        setError(response?.data?.message || "Something went wrong")
      }
    } catch (error) {
      setError(error?.message || "Something went wrong")
    } finally {
      setLoading(false)
    }
  }

  if (!allowReOrder) {
    return null
  }

  return (
    <>
      <button
        className="cancel-order-button reorder-btn"
        disabled={loading}
        onClick={handleReOrder}
      >
        {loading ? "Please wait..." : "Re-Order"}
      </button>
      {error ? <span className="error-message">{error}</span> : null}
    </>
  )
}

export default ReOrder
